// Vendors
import $ from 'jquery';

/**
 * DataLayer Events
 *
 * hn_ab_test_exposure
 * homepage_cta_bar_opened
 * homepage_cta_bar_fixed
 * homepage_cta_bar_reverted
 * homepage_cta_bar_closed
 *
 */

// ---------- helpers ----------
function pushDL(obj) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);
}
function isoNow() {
  return new Date().toISOString();
}

document.addEventListener('DOMContentLoaded', function () {
  // ---------- A/B exposure (generic) ----------
  const recipeSection = document.querySelector('section.single-recipe');
  const homePageSection = document.querySelector('.home-page');
  const defaultEventName = 'hn_ab_test_exposure';

  if (recipeSection) {
    const modalCookie = recipeSection.getAttribute('data-modal-cookie');
    const shareCookie = recipeSection.getAttribute('data-share-cookie');

    if (modalCookie) {
      pushDL({
        event: defaultEventName,
        ab_area: 'recipe',
        ab_test: 'recipe-modal',
        ab_variant: String(modalCookie) === '1' ? 'A' : 'B',
        timestamp: isoNow()
      });
    }
    if (shareCookie) {
      pushDL({
        event: defaultEventName,
        ab_area: 'recipe',
        ab_test: 'recipe-share',
        ab_variant: String(shareCookie) === '1' ? 'A' : 'B',
        timestamp: isoNow()
      });
    }
  }

  if (homePageSection) {
    const homepageCtaCookie = homePageSection.getAttribute(
      'data-homepage-cta-cookie'
    );
    const homepageShowCta = homePageSection.getAttribute(
      'data-homepage-show-cta'
    ); // "true"/"false"

    if (homepageCtaCookie && typeof homepageShowCta === 'string') {
      pushDL({
        event: defaultEventName,
        ab_area: 'home',
        ab_test: 'homepage-cta',
        ab_variant: String(homepageCtaCookie) === '1' ? 'A' : 'B',
        showCta: homepageShowCta === 'true',
        timestamp: isoNow()
      });
    }
  }

  // ---------- Homepage CTA bar behavior ----------
  const ctaBar = document.querySelector('.call-to-action-bar');
  // Guard: if banner doesn't exist, bail (prevents null getBoundingClientRect error)
  if (!ctaBar) return;

  const closeBtn = document.getElementById('close-call-to-action-bar');
  const ctaButton = document.querySelector('.call-to-action-bar__button .btn');

  let closed = false;

  // These booleans ensure each event fires at most once per pageview
  let openedSent = false;
  let fixedSent = false;
  let revertedSent = false;

  // Thresholds are computed after animation starts
  let ctaBarBottom = 0;

  function recalcThreshold(extra = 0) {
    const rect = ctaBar.getBoundingClientRect();
    ctaBarBottom = rect.bottom + window.scrollY + extra;
  }

  function onOpenedOnce() {
    if (openedSent) return;
    openedSent = true;
    pushDL({
      event: 'homepage_cta_bar_opened',
      eventLabel: 'Homepage CTA Bar Opened',
      timestamp: isoNow()
    });
  }

  function onFixedOnce() {
    if (fixedSent) return;
    fixedSent = true;
    pushDL({
      event: 'homepage_cta_bar_fixed',
      eventLabel: 'Homepage CTA Bar Fixed',
      timestamp: isoNow()
    });
  }

  function onRevertedOnce() {
    if (revertedSent) return;
    revertedSent = true;
    pushDL({
      event: 'homepage_cta_bar_reverted',
      eventLabel: 'Homepage CTA Bar Reverted',
      timestamp: isoNow()
    });
  }

  // Kick off reveal animation after slight delay
  setTimeout(() => {
    if (closed) return; // in case it was closed super early
    ctaBar.classList.add('cta--in', 'fade--in');

    // Recalculate after classes apply; keep your original extra offset (400)
    recalcThreshold(400);
    onOpenedOnce();
    checkScrollPosition(); // run an initial check after open
  }, 1500);

  function checkScrollPosition() {
    if (closed) {
      ctaBar.classList.remove('cta--in', 'fade--in', 'cta--fixed');
      ctaBar.classList.add('fade--out');
      return;
    }

    const scrollY = window.scrollY || window.pageYOffset;

    // Move to fixed (position 3) once scrolled past threshold + 100
    if (scrollY > ctaBarBottom + 100) {
      ctaBar.classList.remove('fade--out');
      ctaBar.classList.add('cta--fixed', 'fade--in', 'cta--in');

      if (ctaButton) ctaButton.classList.add('btn--fixed');
      onFixedOnce();
      return;
    }

    // Move to fade-out (position 2) when just past threshold (optional visual state)
    if (scrollY > ctaBarBottom && scrollY <= ctaBarBottom + 100) {
      ctaBar.classList.remove('cta--in', 'fade--in', 'cta--fixed');
      ctaBar.classList.add('fade--out');
      return;
    }

    // Otherwise we’re back to original (position 1)
    ctaBar.classList.remove('cta--fixed', 'fade--out');
    ctaBar.classList.add('cta--in', 'fade--in');
    if (ctaButton) ctaButton.classList.remove('btn--fixed');
    onRevertedOnce(); // fire once per pageview
  }

  // Initial threshold before animation (no +400 yet)
  recalcThreshold(0);
  checkScrollPosition();

  window.addEventListener('scroll', checkScrollPosition);
  window.addEventListener('resize', () => {
    recalcThreshold(0);
    checkScrollPosition();
  });

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      ctaBar.classList.remove('cta--in', 'fade--in');
      ctaBar.classList.add('fade--out', 'cta--closed');
      closed = true;

      pushDL({
        event: 'homepage_cta_bar_closed',
        eventLabel: 'Homepage CTA Bar Closed',
        timestamp: isoNow()
      });
    });
  }
});
